import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import TableContainer from 'Common/TableContainer';
import Select from 'react-select';
import { Loader } from '../../../Common/Loader'
// Icons
import { Pencil, Search, Trash2, Plus, CopyPlus, Eye, } from 'lucide-react';
import { format } from 'date-fns';// Icons

import {
    getOrdersBySalesRep,
    getSalesReps,
} from '../../../helpers/backend_helper';
import { ToastContainer } from 'react-toastify';
import { Common } from 'helpers/common';
import PermissionProvider from 'permissionProvider/PermissionProvider';

const OrdersBySalesRep = () => {
    const [orderList, setOrderList] = useState([]);
    const [eventData, setEventData] = useState<any>();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const navigate = useNavigate();
  const [salesReps, setSalesReps] = useState<any[]>([]);
  const [selectedSalesRep, setSelectedSalesRep] = useState<any>();

    const [brands, setBrands] = useState<any[]>([]);
    const [selectedBrand, setSelectedBrand] = useState<any>();
    const uiHelper = new Common();
    useEffect(() => {
        loadSalesReps();
    }, [])

  const loadSalesReps = async () => {
    let response = await getSalesReps();
    if (response.success) {
      const items = [{ value: '', label: 'Select' }, ...(response.data as any[]).map(item => ({ value: item.id, label: item.fullName }))]
      setSalesReps(items);
   }
  }

    async function loadOrders(item: any) {
        try {
            setIsLoading(true)
            setOrderList([]);

            let response = await getOrdersBySalesRep(item.value.toString());
            if (response.success) {
                setOrderList(response.data as never[]);
            }
            setIsLoading(false)
        } catch (error) {

        } finally {
            setIsLoading(false)
        }
    }
    // Update Data
    const handleEditDataClick = (ele: any) => {
        console.log(ele);
        navigate('/product-create/' + ele.id);
    };

    // Copy Data
    const handleCopyDataClick = (ele: any) => {
        console.log(ele);
        navigate('/product-create/copy/' + ele.id);
    };

    // Add Data
    const handleAddProduct = () => {
        navigate('/product-create');
    }


    // columns
    const Status = ({ item }: any) => {
        switch (item) {
            case true:
                return (<span className="status px-2.5 py-0.5 inline-block text-xs font-medium rounded border bg-green-100 border-transparent text-green-500 dark:bg-green-500/20 dark:border-transparent">Active</span>);
            case false:
                return (<span className="status px-2.5 py-0.5 inline-block text-xs font-medium rounded border bg-orange-100 border-transparent text-orange-500 dark:bg-orange-500/20 dark:border-transparent">InActive</span>);
        }
    };

    const columns = useMemo(() => [
        {
            header: "Customer",
            accessorKey: "fullName",
            enableColumnFilter: true,
            enableSorting: false,
        },
        {
            header: "Business Name",
            accessorKey: "businessName",
            enableColumnFilter: true,
            enableSorting: false,
        },
        {
            header: "Order Date",
            accessorKey: "orderDate",
            enableColumnFilter: true,
             cell: (cell: any) => (
                            <p>{format(cell.getValue(), 'dd MMM, yyyy')}</p>
                        ),
        },
        {
            header: "Amount ( ₹ )",
            accessorKey: "totalAmount",
            enableColumnFilter: true,
cell: (cell: any) => (
                <p >  {Math.round(cell.getValue())}</p>
            ),
        },
        {
            header: "Action",
            enableColumnFilter: false,
            enableSorting: false,
            cell: (cell: any) => (
                <div className="flex justify-start gap-2" >

                <Link to={"/order-detail/" + cell.row.original.orderId}
                    className="flex items-center justify-center size-8 transition-all duration-200 ease-linear rounded-md text-custom-500 bg-custom-100 hover:text-white hover:bg-custom-500 dark:text-zink-200 dark:bg-zink-600 dark:hover:text-white dark:hover:bg-zink-400"
                >
                    <Eye className="inline-block size-4 ltr:mr-1 rtl:ml-1" /> 
                </Link>

                </div>
            ),
        }
    ], []
    );

    return (
        <PermissionProvider >

            <React.Fragment>
                <ToastContainer closeButton={false} limit={1} />

                <div className="grid grid-cols-1 gap-x-5 xl:grid-cols-12" style={{ marginTop: 15 }}>
                    <div className="xl:col-span-12">
                        <div className="card" id="categoriesTable">
                            {/* <div className="card-body  border-y border-dashed "> */}
                            <div className="flex items-center justify-between border-y border-dashed" style={{ padding: 10 }}>
                                <div className="flex justify-start">
                                <h6 className="text-15 grow" style={{marginRight:50, marginTop:10}}>Orders By Sales Rep</h6>


                                    {/* <label htmlFor="brandId" className="inline-block mb-2 text-base font-medium">Brand</label> */}
                                    <Select
                                    placeholder="Search by sales rep"
                                        className="border-slate-200 w-80 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                                        options={salesReps}
                                        value={selectedSalesRep}
                                        defaultValue={selectedSalesRep}
                                        isSearchable={true} // To disable search
                                        name="salesRep"
                                        id="salesRep"
                                        onChange={e => { loadOrders(e); }}
                                    />
                                </div>
                                <div className="shrink-0">

                                </div>
                            </div>
                            {/* </div> */}
                            {/* <div className="!py-3.5 card-body border-y border-dashed border-slate-200 dark:border-zink-500">
                                        <form action="#!">
                                            <div className="grid grid-cols-1 gap-5 xl:grid-cols-12">
                                                <div className="xl:col-span-2">
                                                    <Select
                                                        className="border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                                                        options={options}
                                                        isSearchable={false}
                                                        defaultValue={options[0]}
                                                        onChange={(event: any) => handleChange(event)}
                                                        id="choices-single-default"
                                                    />
                                                </div>

                                            </div>
                                        </form>
                                    </div> */}
                            {isLoading ? (<Loader />) :
                                (<div style={{ marginBottom: 20 }} >
                                    {orderList && orderList?.length > 0 ?
                                        <TableContainer
                                            isPagination={true}
                                            columns={(columns || [])}
                                            data={(orderList || [])}
                                            customPageSize={15}
                                            divclassName="overflow-x-auto"
                                            tableclassName="w-full whitespace-nowrap"
                                            theadclassName="ltr:text-left rtl:text-right bg-slate-100 dark:bg-zink-600"
                                            thclassName="px-3.5 py-1.5 font-semibold border-b border-slate-200 dark:border-zink-500"
                                            tdclassName="px-3.5 py-1.0 border-y border-slate-200 dark:border-zink-500"
                                            PaginationClassName="flex flex-col items-center gap-4 px-4 mt-3 md:flex-row"
                                            SearchPlaceholder='Search...'
                                            isGlobalFilter={false}
                                            isSelect={true}

                                        />
                                        :
                                        (<div className="noresult">
                                            <div className="py-6 text-center">
                                                <Search className="size-6 mx-auto text-sky-500 fill-sky-100 dark:sky-500/20" />
                                                <h5 className="mt-2 mb-1">Sorry! No Result Found</h5>
                                            </div>
                                        </div>)}
                                </div>)
                            }
                        </div>
                    </div>
                </div>


            </React.Fragment>
        </PermissionProvider>
    );
};

export default OrdersBySalesRep;
